import React, { useContext, useRef, useState } from "react";
import { AiOutlineFile, AiOutlineDelete, AiOutlineEdit, AiOutlineUpload } from "react-icons/ai";

import { StyledFile } from "./Tree.style";
import { useTreeContext } from "./TreeContext";
import { ActionsWrapper, StyledName } from "./Tree.style.js";
import { PlaceholderInput } from "./TreePlaceholderInput";
import FILE_ICONS from "./FileIcons";
import Actions from "./ActionConst.js";
import AppContext from "../../../Context/AppContext.js";
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox } from "antd";
import { SelectedFiles } from "../../../Context/ReduxContext.js";

const File = ({selectedFile,thisData, name, type, id, parent }) => {
  const [isEditing, setEditing] = useState(false);
  const { state, dispatch, isImparative, onNodeClick, onUpload } = useTreeContext();
  const SelectedFile = useSelector((state) => state.AppReduxContext.SelectedFiles); // Read state
  const FolderPickerSelecetdPath = useSelector((state) => state.AppReduxContext.FolderPickerSelecetdPath);
  const dispatchContext = useDispatch();
  const ext = useRef("");

  let splitted = name && name.split(".");
  ext.current = splitted && splitted[splitted.length - 1];

  const onCheckedFile = (checked,file) =>{
    
    let arr = {...SelectedFile};
    if(checked.target.checked){
      arr[file.id] = file;
    }else{
      delete arr[file.id];
    }
    dispatchContext(SelectedFiles(arr));
  }

  return (
    <StyledFile
      onClick={event => {
        event.stopPropagation();
        onNodeClick({
          state,
          name,
          id,
          parent,
          type: type,
          prevUrl: thisData.prevUrl,
        });
      }}
      className="tree__file"
    >
      {isEditing ? (
        <PlaceholderInput
          defaultValue={name}
          type="file"
          style={{ marginLeft: 0 }}
          handleSubmit={name => {
            dispatch({ type: "EDIT_FILE", payload: { id, name } });
            setEditing(false);
          }}
        />
      ) : (
        <ActionsWrapper className={`Parent-Class ${(selectedFile?.id == id || SelectedFile[id] || FolderPickerSelecetdPath?.includes(id)) && "Selected"}`}>
          <StyledName className="Text-Color">
            <Checkbox checked={SelectedFile[id]} onChange={(checked)=>{
              onCheckedFile(checked,thisData)
            }} className="mr-1" />
            {FILE_ICONS[type] ? (
              FILE_ICONS[type]
            ) : (
              <AiOutlineFile />
            )}
            &nbsp;&nbsp;<span className="Elipsis-Class">{name}</span>
          </StyledName>
          {isImparative && (
            <div className="actions mr-2">
              {/* <AiOutlineEdit onClick={() => setEditing(!isEditing)} /> */}
              {/* <AiOutlineDelete
                onClick={() => {
                  dispatch({ type: "DELETE_FILE", payload: { id } });
                }}
              /> */}
              {/* <AiOutlineUpload
                onClick={(event) => {
                  event.stopPropagation();
                  onUpload({
                    // state,
                    name,
                    id,
                    parent,
                    type: type
                  })
                }}
              /> */}
            </div>
          )}
        </ActionsWrapper>
      )}
    </StyledFile>
  );
};

export { File };
